import { render, staticRenderFns } from "./headNoLoginMenu.vue?vue&type=template&id=a23135f6&scoped=true"
import script from "./headNoLoginMenu.vue?vue&type=script&lang=js"
export * from "./headNoLoginMenu.vue?vue&type=script&lang=js"
import style0 from "./headNoLoginMenu.vue?vue&type=style&index=0&id=a23135f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23135f6",
  null
  
)

export default component.exports